import React from 'react'
import "./header.css"
export const Header = () => {
  return (
    <div className='content'>
    <h2 className='text_shadows'> Heart Calculator</h2>
    </div>
  )
}
